import { Badge } from '@/components/ui/badge'
import type { UnitStatus, DisplayStatus } from '@/lib/reports/space-yield/types'
import { toDisplayStatus } from '@/lib/reports/space-yield/types'

const DISPLAY_CONFIG: Record<DisplayStatus, { className: string; dotColor: string; isOutline: boolean }> = {
  'Leased':      { className: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-200', dotColor: 'bg-emerald-500', isOutline: false },
  'M2M':         { className: 'bg-purple-100 text-purple-800 hover:bg-purple-200',    dotColor: 'bg-purple-500',  isOutline: false },
  'Transient':   { className: 'bg-blue-100 text-blue-800 hover:bg-blue-200',          dotColor: 'bg-blue-500',    isOutline: false },
  'Idle':        { className: 'text-slate-500 border-slate-300',                       dotColor: 'bg-slate-300',   isOutline: true },
  'No Contract': { className: 'bg-red-100 text-red-800 hover:bg-red-200',             dotColor: 'bg-red-500',     isOutline: false },
}

interface StatusBadgeProps {
  status: UnitStatus
  onClick?: () => void
}

export function StatusBadge({ status, onClick }: StatusBadgeProps) {
  const displayStatus = toDisplayStatus(status)
  const config = DISPLAY_CONFIG[displayStatus]

  return (
    <Badge
      variant={config.isOutline ? 'outline' : 'default'}
      className={`${config.className} ${onClick ? 'cursor-pointer' : ''} gap-1.5 font-medium`}
      onClick={onClick}
    >
      <span className={`inline-block w-2 h-2 rounded-full ${config.dotColor}`} />
      {displayStatus}
    </Badge>
  )
}
